import React from 'react'
import styled from '@emotion/styled'
import { PartnerItem } from './Item'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import { Partner } from 'services/ContentfulService/models/partner/partner'

interface Props {
	partners: Partner[]
}
export const PartnerItems = ({ partners }: Props): JSX.Element => {
	const truncatedPartners = partners.length > 6 ? partners.slice(0, 6) : partners

	return (
		<PartnersWrapper>
			{truncatedPartners.map(partner => (
				<PartnerItemHolder key={partner.id}>
					<PartnerItem partner={partner} />
				</PartnerItemHolder>
			))}
		</PartnersWrapper>
	)
}

const PartnersWrapper = styled.div`
	display: grid;
	grid-gap: 24px;
	grid-template-columns: 1fr 1fr 1fr;

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		display: flex;
		flex-wrap: nowrap;
		overflow-x: auto;
		padding: 24px 20px;
		margin: 0 -20px;
		grid-gap: 0;
		-webkit-overflow-scrolling: touch;

		&::-webkit-scrollbar {
			display: none;
		}
	}
`

const PartnerItemHolder = styled.div`
	@media screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		padding-right: 20px;
		&:last-of-type {
			padding-right: 20px;
		}
	}
`
